import List from "@/components/list";
import router from "@/router";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  // 学员成绩
  function goClassGroup(data) {
    let query = { classId: data.classId,examName:data.examName,examType:data.examType}
    if (data.classChildId) {
      query.childId = data.classChildId;
    }
    router.push({
      path: "examDetailPage",
      query: query,
    });
  }
  const Deal = ({ props: { vo } }) => {
    const data = vo.row;
    return (
      <div class="deal-group">
        <el-tooltip
          content="学员成绩"
          placement="top"
          style="margin-right:20px"
        >
          <i class="icon_chengji_icon"
            onClick={() => goClassGroup(data)}
          ></i>
        </el-tooltip>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "测试名称",
      prop: "examName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "测试类型",
      prop: "examTypeName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "120",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
